module.exports = __webpack_public_path__ + "static/img/bottom6.251aaeba.jpg";